<template>
	<div v-show="bodyIsShow">
		<section id="formwrapSection" class="formwrapSection clearfix bac">
		<div class="formwrap">
			<form id="signUpfrom" class="signUpfrom" action="/hmtcj/applyForTcj" method="post">
				<img  :src="commmonWebConfig.webCommonUtils+'/img/mapply/carExpo/succes.png'"/>
				<p class="titleFont">领票成功</p>
				<div style="margin-bottom:1em;color:#999;text-align: center;margin-top: 0.46rem;" class="addxyroom">稍后会有客服与您确认门票事宜，请注意接听！</div>
				<div class="sub-wrap">
                    <div class="singsubmit tobtn" @click="backTo()" data-track="carfestivalDetailToutiao-1-signUp" id="index-submit" ut-data-click ut-data-convertid="42715" ut-data-eventtype="FormSubmit">
                        	返回首页
                    </div>
                </div>
			</form>
		</div>
		</section>
	</div>
</template>

<style scoped lang="less">
	@import "../../assets/less/common.less";
	 body {
        background-color: #1b1880;
    }
	.titleFont{
		.px2px(font-size, 36px);
		text-align:center;
		color:#fff;
		margin-top:0.93rem;
		margin-bottom:0.37rem;
	}
	.formwrap{
		width: 10.0rem;
		height: 100%;
	    margin: 0 auto;
	    padding-bottom: 1.5rem;
		background: #1b1880;
	}
</style>
<script>
import { Toast } from 'mint-ui';
export default {
	name: 'perfect',
	data:function() {
		return {
			bodyIsShow:false,
			periods:{
				cityId:10,
				successBannerList:[],
				// 已换成真实数据
				improveInfoTextFlag:1,
				// 已换成真实数据
				improveInfoText:"",
				// 已换成真实数据
				improveInfoPicFlag:1,
				// 已换成真实数据
				improveInfoPic:"",
				successBannerCb:false,
				picUrl:""
			},
			abTestFlag:null,
			// 已换成真实数据
			isTicket:null,
			address:null,
			// 已换成真实数据;
			car:null,
			buyway:1,
			buyList:[],
			// 已换成真实数据
			instalments:1,
			activityType:'9'            //场次类型
			
		}
	},
	mounted:function(){
		var self = this;
		getCommonJsIns.initCSSNEW();
		getCommonJsIns.initSingleCSSNEW({
			cssURL: "/css/mapply/carExpo/carExpoSuccess.css?v=123"
		});
		document.title="报名成功";
		// var applyId = "${applyId}";
	 //    var periodsId = '${periodsId}';
	 //    var sk = '${sk}';
	 //    var leaseCity = '${leaseCity}';
	 //    var lastInstalments = '${lastInstalments}';
	    window.cityId = self.$route.query.cityId;
	    self.periods.cityId =  self.$route.query.cityId;
		getCommonJsIns.initDefaultJS(self.webReady);
		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
	            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
	        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

	    ga('create', 'UA-28316522-1', 'auto');
	    ga('send', 'pageview');

	},
	methods:{
		
		webReady:function(){
			var self = this;
			this.bodyIsShow = true;
			if(self.$route.query.activityType==undefined){
				//
			}else{
				self.activityType=self.$route.query.activityType;
			}
		},
		backTo:function(){
			var self = this;
			window.location.href = "/mapply/carExpo?cityPy="+self.$route.query.cityPy+"&activityType="+self.activityType
		}


		
	}
}
</script>


// WEBPACK FOOTER //
// src/views/carExpo/carExpoSuccess.vue